import { createSetData } from '../../../shared/utils/createSetData';
import store from './store';

export * from './events';
export { store };
export const setData = createSetData(store);
